import React, { useState, useEffect } from 'react';
import { generatePasswordResetUrl } from '../services/apiService';

interface PasswordResetModalProps {
  employeeName: string;
  onClose: () => void;
}

const PasswordResetModal: React.FC<PasswordResetModalProps> = ({ employeeName, onClose }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');
  const [resetUrl, setResetUrl] = useState<string>('');
  const [expiresAt, setExpiresAt] = useState<string>('');
  const [copied, setCopied] = useState<boolean>(false);

  useEffect(() => {
    const generateUrl = async () => {
      try {
        const result = await generatePasswordResetUrl(employeeName);
        setResetUrl(result.resetUrl);
        setExpiresAt(result.expiresAt);
      } catch (error: any) {
        if (error.response?.data?.error) {
          setError(error.response.data.error);
        } else {
          setError('Fehler beim Generieren des Reset-Links. Bitte versuchen Sie es erneut.');
        }
      } finally {
        setLoading(false);
      }
    };

    generateUrl();
  }, [employeeName]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(resetUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      setError('Fehler beim Kopieren in die Zwischenablage');
    }
  };

  const formatExpirationTime = (isoString: string) => {
    const date = new Date(isoString);
    return date.toLocaleString('de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Passwort zurücksetzen für {employeeName}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {loading && <p>Link wird generiert...</p>}

          {error && <div className="error-message">{error}</div>}

          {!loading && !error && (
            <>
              <p style={{ marginBottom: '10px' }}>
                Senden Sie den folgenden Link an den Mitarbeiter:
              </p>
              <div style={{ marginBottom: '20px' }}>
                <textarea
                  readOnly
                  value={resetUrl}
                  style={{
                    width: '100%',
                    minHeight: '80px',
                    padding: '10px',
                    fontFamily: 'monospace',
                    fontSize: '12px',
                    resize: 'vertical',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                  }}
                />
              </div>
              <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
                Gültig bis: {formatExpirationTime(expiresAt)}
              </p>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={handleCopy}
                  className="login-button"
                  style={{ flex: 1 }}
                >
                  {copied ? 'Kopiert!' : 'In Zwischenablage kopieren'}
                </button>
                <button
                  onClick={onClose}
                  className="login-button"
                  style={{ flex: 1, backgroundColor: '#6c757d' }}
                >
                  Schließen
                </button>
              </div>
            </>
          )}

          {!loading && error && (
            <button onClick={onClose} className="login-button">
              Schließen
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasswordResetModal;
